//@ts-ignore
import { EVALUABLE_CLESSON_MODES } from '@yandex-int/k-common/constants';
import { CLessonInCourse, EXTERNAL_LMS_SLUGS } from '@yandex-int/k-common/typings';
import {
    ClockClear as IconClock,
    Count as IconCount,
    Video as IconVideo,
    MesLogo as MesLogoIcon,
} from 'education-icons';
import React from 'react';

import './lessons__lesson-icon.scss';

interface Props {
    clesson: CLessonInCourse;
}

export const LessonIcon = (props: Props) => {
    const { clesson } = props;
    const { stream, mode, external_homework: externalHomework } = clesson;
    const hasStream = Boolean(stream);

    if (externalHomework?.lms === EXTERNAL_LMS_SLUGS.MES) {
        return <MesLogoIcon className="lessons__lesson-icon-mes" />;
    }

    if (hasStream) {
        return <IconVideo />;
    }

    if (EVALUABLE_CLESSON_MODES.includes(mode)) {
        return <IconClock />;
    }

    return <IconCount />;
};

export default LessonIcon;
